export const Boxing = [
    {
        "id": 31,
        "Title": "IES-2024-31",
        "ImageSource": "/Boxing/BoxingGloves/31.png",
        "Category": "Bag Gloves"
    },
]